import { render, staticRenderFns } from "./viewCourseDetails.html?vue&type=template&id=509ddab0&scoped=true&external"
import script from "./viewCourseDetails.vue?vue&type=script&lang=ts"
export * from "./viewCourseDetails.vue?vue&type=script&lang=ts"
import style0 from "./viewCourseDetails.scss?vue&type=style&index=0&id=509ddab0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509ddab0",
  null
  
)

export default component.exports